export const separatorLightGrey = "#26557326";
export const disabledIconWhite = "#ECEDEE";